import { useState, useContext } from "react";
import { NewsletterContext } from "../context/NewsletterContext";
import { writeNewsletter } from "@/api/newsletter";
import { useAuth } from "@/auth/useAuth";

export const useGenerateNLwTone = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const { session } = useAuth();
  const {
    config: { topics },
    preview,
    updatePreview,
  } = useContext(NewsletterContext);

  const generateNewsletter = async (
    toneOption: string,
    toneFeedback: string
  ) => {
    try {
      setIsGenerating(true);
      const userName =
        session?.user.user_metadata.full_name?.split(" ")[0] || "";
      console.log(
        "Generating newsletter with tone:",
        toneOption,
        "and articles:",
        preview?.articles
      );
      const response = await writeNewsletter({
        userName,
        interests: topics || [],
        articles: preview?.articles || [],
        tone: toneOption,
        toneFeedback,
      });

      const textData = await response.text();
      const data = JSON.parse(textData);

      updatePreview({
        subject: data.subject,
        body: data.body,
        articles: preview?.articles || [],
      });

      return data;
    } catch (error) {
      console.error("Failed to generate newsletter:", error);
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generateNewsletter,
    isGenerating,
  };
};
